/*
 * @Date: 2022-07-04 17:19:47
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 * @desc: 页面Html框架（头部导航栏）
 */
export default {
  home: "公司概覽",

  about: "關於我們",
  companyProfile: "公司簡介", // 關於我們/公司簡介
  management: "管理層成員", // 關於我們/管理層成員
  corporateGovernance: "公司治理", // 關於我們/公司治理
  irNetwork: "投資者關系聯絡", // 關於我們/投資者關系聯絡

  disclosure: "信息披露",
  circulars: "公告與通函", // 信息披露/公告與通函
  stockPrice: "股價信息", // 信息披露/股價信息

  finance: "財務信息",
  quarter: "中期報告", // 財務信息/中期報告
  year: "年度報告", // 財務信息/年度報告

  esg: "ESG 報告"
}